import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { photoAlbums } from '../data/photoAlbums';

const PhotoRedirect = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        const album = photoAlbums.find(a => a.id === id);

        if (album && album.url) {
            window.location.href = album.url;
        } else {
            // Album not found or no URL, redirect back to photos list
            console.warn(`Album with id ${id} not found or has no URL.`);
            navigate('/photos', { replace: true });
        }
    }, [id, navigate]);

    return (
        <div className="container" style={{ padding: '100px 0', textAlign: 'center' }}>
            <h3>Redirecting to photo album...</h3>
            <p>If you are not redirected automatically, <a href="/photos">click here</a> to return to photos.</p>
        </div>
    );
};

export default PhotoRedirect;
